import _defineProperty from "/var/jenkins_home/workspace/tingle.caa77636-11e8-4573-9fa8-b0d26a83c900/workspace/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { cta2FontWeight, spacer16, spacer40, spacer80, screenSmMax } from '@spotify-internal/encore-web';
import { DELAYS, FeaturedContentHeadline, fadeInAnimation, HeadlineWithSupertextComponent, withAnimationContext } from '../../ui';
import { Testimonial } from './Testimonial';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var SingleTestimonial = styled.div.withConfig({
  displayName: "SingleTestimonialModule__SingleTestimonial",
  componentId: "sc-16b2fb-0"
})(["display:flex;flex-direction:row;flex-wrap:wrap;color:", ";background-color:", ";@media (max-width:", "){flex-wrap:nowrap;flex-direction:column;}"], function (_ref) {
  var theme = _ref.theme;
  return theme.box.text;
}, function (_ref2) {
  var theme = _ref2.theme;
  return theme.box.background;
}, screenSmMax);
var StyledTestimonial = styled.div.withConfig({
  displayName: "SingleTestimonialModule__StyledTestimonial",
  componentId: "sc-16b2fb-1"
})(["width:65%;padding-left:", ";@media (max-width:", "){padding-left:0;width:100%;order:4;flex:1;}"], spacer80, screenSmMax);
var StyledFCM = styled.div.withConfig({
  displayName: "SingleTestimonialModule__StyledFCM",
  componentId: "sc-16b2fb-2"
})(["flex:0 0 100%;padding-bottom:", ";@media (max-width:", "){padding-bottom:", ";order:2;}"], spacer40, screenSmMax, spacer16);
var BodyDesktop = withAnimationContext(styled.div.withConfig({
  displayName: "SingleTestimonialModule__BodyDesktop",
  componentId: "sc-16b2fb-3"
})(["", ";@media (max-width:", "){display:none;}"], fadeInAnimation(DELAYS.THIRD), screenSmMax));
var BodyMobile = styled.div.withConfig({
  displayName: "SingleTestimonialModule__BodyMobile",
  componentId: "sc-16b2fb-4"
})(["display:none;@media (max-width:", "){display:inline;padding-bottom:", ";font-weight:", ";width:100%;order:3;flex:1;line-height:initial;}"], screenSmMax, spacer16, cta2FontWeight);
var StyledHWSC = styled.div.withConfig({
  displayName: "SingleTestimonialModule__StyledHWSC",
  componentId: "sc-16b2fb-5"
})(["width:35%;@media (max-width:", "){width:100%;order:1;flex:1;}"], screenSmMax);
export var SingleTestimonialModule = /*#__PURE__*/React.forwardRef(function (_ref3, ref) {
  var _ref3$supertext = _ref3.supertext,
      supertext = _ref3$supertext === void 0 ? '' : _ref3$supertext,
      _ref3$headline = _ref3.headline,
      headline = _ref3$headline === void 0 ? '' : _ref3$headline,
      _ref3$body = _ref3.body,
      body = _ref3$body === void 0 ? '' : _ref3$body,
      _ref3$quote = _ref3.quote,
      quote = _ref3$quote === void 0 ? '' : _ref3$quote,
      image = _ref3.image,
      _ref3$source = _ref3.source,
      source = _ref3$source === void 0 ? '' : _ref3$source,
      _ref3$jobTitle = _ref3.jobTitle,
      jobTitle = _ref3$jobTitle === void 0 ? '' : _ref3$jobTitle,
      _ref3$caption = _ref3.caption,
      caption = _ref3$caption === void 0 ? '' : _ref3$caption;
  var fchProps = {
    supertext: supertext,
    headline: headline,
    image: image,
    caption: caption,
    useFeaturedContentHeadline: false
  };
  var quoteProps = {
    quote: quote,
    source: source,
    jobTitle: jobTitle
  };
  return /*#__PURE__*/_jsxs(SingleTestimonial, {
    ref: ref,
    children: [/*#__PURE__*/_jsx(StyledFCM, {
      children: /*#__PURE__*/_jsx(FeaturedContentHeadline, _objectSpread({}, fchProps))
    }), /*#__PURE__*/_jsxs(StyledHWSC, {
      children: [/*#__PURE__*/_jsx(HeadlineWithSupertextComponent, {
        supertext: supertext,
        headline: headline
      }), /*#__PURE__*/_jsx(BodyDesktop, {
        children: body
      })]
    }), /*#__PURE__*/_jsx(BodyMobile, {
      children: body
    }), /*#__PURE__*/_jsx(StyledTestimonial, {
      children: /*#__PURE__*/_jsx(Testimonial, _objectSpread({}, quoteProps))
    })]
  });
});